<!-- eslint-disable -->
<template>
    <div class="order-list-page">
        <van-sticky>
            <van-nav-bar
                :style="{'paddingTop':statusBarHeight,'backgroundColor':'#FFFFFF'}"
                title="我的订单"
                left-arrow
                @click-left="onClickLeft"
            />
            <van-tabs class="goods-type-box" v-model="tabActive" @click="handleTab" :ellipsis="false" v-if="orderGoodsTypeList.length">
                <van-tab v-for="item in orderGoodsTypeList" :title="item.label" :name="item.value" :key="item.value" />
            </van-tabs>
            <div class="status-nav-box" v-if="[3].includes(tabActive)">
                <van-tabs v-model="orderType" swipeable @click="handleStatus">
                    <van-tab class="status-nav-item" v-for="item in orderStatus[tabActive]" :title="item.label" :name="item.value" :key="item.value" />
                </van-tabs>
            </div>
        </van-sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                loading-text="加载中"
                :finished-text="filter.pageNum != 1 && listData.length? '-没有更多了-' : ''"
                :error.sync="error"
                error-text="加载失败，重试"
                :immediate-check="false"
                @load="onLoad"
            >
              <template v-if="tabActive==1">
                  <!-- 培训订单 -->
                  <ul class="orderul" >
                      <li class="orderli" v-for="(order, index) in listData" :key="index" v-show="!order.orderAddr">
                          <div class="orderinfo">
                              <!-- 0 未支付；1 支付中；2 已支付；8 已关闭；9 已取消 -->
                              <img v-if="order.status === 0" class="payicon" src="../../../assets/images/account/waitpay.png" alt="">
                              <img v-else-if="order.status === 7" class="payicon" src="../../../assets/images/account/waitsure.png" alt="">
                              <img v-else-if="order.status === 2" class="payicon" src="../../../assets/images/account/finishpay.png" alt="">
                              <img v-else-if="order.status === 8 || order.status === 9 || order.invoiceStatus==3" class="payicon" src="../../../assets/images/account/closepay.png" alt="">
                              <p class="orderText">订单编号：<span>{{order.orderNo}}</span></p>
                              <p class="orderText">下单时间：<span>{{order.orderTime}}</span></p>
                              <p v-if="order.payWay" class="orderText">支付方式：<span>{{order.payWay}}</span></p>
                          </div>
                          <div class="orderCurseInfo" v-for="(item, ind) in order.goodsList" :key="ind">
                              <img class="orderCourseImg" :src="item.picUrl" alt="" @click="goDetails(item,order)">
                              <!-- <div> -->
                              <h3 @click="goDetails(item,order)">
                                  <span v-if="order.groupOrderTag" class="pt-icon">拼团</span>
                                  <span class="title-text">{{item.name}}</span>
                              </h3>
                              <!-- </div> -->
                          </div>
                          <div class="order-bottom">
                              <div class="orderprice">金额：<span>￥{{order.realPay}}</span></div>
                              <div class="btn_wrap">
                                  <div class="btn_pay">
                                      <button @click="handleApply(order.id,order.orderTime,index)"  class="applyBtn" v-if="order.invoiceStatus == 1 && order.status == 2 && order.realPay != 0 && isInvoice">申请开票</button>
                                      <button @click="handlePreview(order.invoiceId)" class="previewBtn" v-else-if="order.invoiceStatus== 2 && order.status == 2 && isInvoice">查看开票</button>
                                      <button @click="goPayment(order.goodsList[0],order)" class="payBtn" v-if="order.status==0">去付款</button>
                                      <button @click="cancelPayment(order)" class="groupBtn" style="margin-left:3px;width:4.2rem;" v-if="order.status==0">取消订单</button>
                                      <button class="groupBtn" @click="toGroupDetail(order.orderNo)" v-if="order.status==7">查看拼团详情</button>
                                  </div>
                                  <!-- evaluationTag 0：隐藏 1：查看评价 2：评价 3：禁用  -->
                                  <template v-if="order.evaluationTag>0 && isEvaluateBtn"> 
                                      <div class="evaluate">
                                          <button @click="onEvaluate(order)"
                                                  class="btn_evalute"
                                                  :class="{
                                                      'c1':order.evaluationTag==1,
                                                      'c2':order.evaluationTag==2,
                                                      'c3':order.evaluationTag==3,
                                                  }">
                                                  {{ onStatus(order.evaluationTag) }}
                                          </button>
                                      </div>
                                  </template>
                              </div>
                          </div>
                      </li>
                  </ul>
              </template>
              <!-- 商品订单 -->
              <template v-else-if="tabActive == 3">
                  <div class="list-box" v-for="(item,itemIndex) in listData" :key="itemIndex" @click="handleDetail(item.orderNo)">
                      <div class="list-item">
                          <div class="num-box">
                              <p class="num-item">
                                  <span class="name">订单编号：</span>
                                  <span class="info">{{item.orderNo}}</span>
                              </p>
                              <p class="num-item">
                                  <span class="name">{{item.exchangeTag?'兑换时间':'下单时间'}}：</span>
                                  <span class="info">{{item.createTime}}</span>
                              </p>
                              <div class="status-text">{{ item.refundApplicationState === 7 ? '已关闭' :item.deliveryStatus > 2 ? item.deliveryStatusName : item.statusName}}</div>
                          </div>
                          <goodsCard v-for="(goodsDetail,index) in item.goodsList"  
                              :key="index" 
                              :card-data="{
                                  ...goodsDetail,
                                  sku: (goodsDetail.skuInfo || []).join(',')
                              }" 
                          />
                          <div class="pay-info-box" 
                              :class="{'no-pay': (item.exchangeTag || item.status === 0 || (tabActive === 5 && (![9].includes(item.status))))}"
                              v-if="![8,9].includes(item.status)" >
                              <div class="pay-info-item">
                                  <div class="pay-info-num">
                                      <p>总价：¥ {{item.totalMoney}}</p> 
                                      <p v-if="tabActive === 3 || tabActive === 5">运费：{{!item.postMoney? '包邮': `¥ ${item.postMoney}`}}</p>
                                  </div>
                                  <p class="pay-info-num">{{item.status === 0? '需付款：':'实付款：'}}<span>¥ {{item.realPay}}</span></p>
                              </div>
                              <div class="pay-btn" v-if="item.status === 0 && item.refundApplicationState === null">
                                  <van-button plain type="primary" @click.stop="handlePay(item)">去付款</van-button>
                              </div> 
                             
                              <div class="pay-btn" v-if="tabActive === 5 && item.refundApplicationState !== null">
                                  <!-- <van-button plain type="primary" class="refund-btn" v-if="item.refundApplicationState === null" @click.stop="goRefund(item)">退款</van-button> -->
                                  <p class="refund-text" v-if="item.refundApplicationState === 7">售后处理已完成</p>
                                  <p class="refund-text" v-else-if="item.refundApplicationState === 9">退款已拒绝</p>
                                  <p class="refund-text" v-else>退款进行中</p>
                              </div>
                              <div v-if="item.exchangeTag" class="exchangeTag"></div>

                          </div>
                      </div>
                  </div>
              </template>
              <!-- 线下订单 -->
              <template v-else-if="+tabActive == 0">
                  <div class="offlineOrderItem" v-for="item in offlineOrderList" :key="item.id">
                      <img src="../asset/images/pay-successicon.png" v-if="item.status === 1" class="pay-icon" alt="" />
                      <img src="../asset/images/pay-closeicon.png" v-if="item.status === 2" class="pay-icon" alt="" />
                      <p class="orderNo">
                        <span class="label">订单编号：</span>
                        <span class="con">{{item.orderNo}}</span>
                      </p>
                      <p class="tradeTime">
                        <span class="label">支付时间：</span>
                        <span class="con">{{item.tradeTime}}</span>
                      </p>
                      <div class="details">
                          <img src="../asset/images/offlineOrder-pic.png" alt="">
                          <p class="name">{{item.classTypeStr}}</p>
                      </div>
                      <div class="bottom">
                          <p class="paymentAmount">
                              <span class="label">金额：</span>
                              <span class="con" v-if="item.paymentAmount">¥ {{item.paymentAmount}}</span>
                          </p>
                          <p class="button" v-if="item.status !== 2" @click="gohtmlPdf(item)">电子凭证</p>
                      </div>
                  </div>
              </template>
              <empty v-if="(!listData.length && [1,3].includes(tabActive)) || (!offlineOrderList.length && +tabActive == 0) " />
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
import { orderGoodsTypeList, orderStatusList, entityOrderStatusList, payStatusList,compositeOrderStatusList,memberOrderStatusList } from '../config/enum';
import goodsCard from '../components/card.vue';
import { Toast } from "vant";
import { mapState } from 'vuex'
// import AMapLoader from '@amap/amap-jsapi-loader';
// import { errorMonitor } from 'events';

export default {
    components: {
        goodsCard,
        ...mapState(['isNewSaas']),
    },
    data() {
        return {
            isEvaluateBtn:true,// 是否显示评价按钮
            isInvoice:true,// 是否显示开票按钮
            offlineOrderList:[],
            ordertypelist:null,
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            dataLoading: false,
            statusBarHeight: 0,
            error: false,
            loading: true,
            finished: false,
            refreshing: false,
            goodsKinds: Number(this.$route.params.type) || 1,
            orderType: Number(this.$route.params.orderStatus) ||  '', 
            filter: {
                pageNum: 1,
                pageSize: 10,
            },
            listData: [],
            orderGoodsTypeList:[],
            orderStatus: {
                1: orderStatusList,
                3: entityOrderStatusList,
                5: compositeOrderStatusList,
                6:memberOrderStatusList
            },
            tabActive: Number(this.$route.params.type) || 1,
            // isInApp: false,
            lng: '',
            lat: '',
            province: '',
            city: '',
            distinct: '',
            timer:null,
        }
    },
    async created () {
        // this.initMap();
        await this.configMenuInfor();
        this.setCompatible();
        if(this.tabActive){
          await this.getDataList();
        }else{
          await this.getOfflineOrderData();
        }
        // this.getDataList();
        this.countDown();
        // this.$WDJSBridge.useGetAppVersion().then(res=>{
        //     console.log('获取版本号成功', res)
        //     this.isInApp = res?true:false;
        // }).catch(err=>{
        //     console.log('获取版本号失败', err)
        // })
        
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.onClickLeft, false); //false阻止默认事件
        }
    },
    destroyed(){
        clearInterval(this.timer);
        window.removeEventListener("popstate", this.onClickLeft, false)
    },
    methods: {
        cancelPayment(order){
            this.$api.orderPage.cancelOrder(order.orderNo).then(res=>{
                console.log(res)
                if(res.code==0){
                    Toast({
                        message:'订单取消成功',
                    });
                    this.filter.pageNum=1;
                    this.getDataList();
                }
            })
        },
        toGroupDetail(orderNo){
            this.$router.push({
                path:'/grouppurchasedetail',
                query:{
                    orderNo:orderNo,
                    showBack:1
                }
            })
        },
        gohtmlPdf(item){
            sessionStorage.setItem('certificateUrl',item.certificateUrl);
            sessionStorage.setItem('certificateViewUrl',item.certificateViewUrl)
            this.$router.push({
                path:'/offllineOrderCertificate',
            })
        },
        //获取是否显示订单tab
        configMenuInfor(){
            const frontendConfig = this.$store.state.dynamic.frontendConfig || [];
            return frontendConfig.length && frontendConfig.filter( (item) => {
                switch(item.key) {
                    case  "is_show_orderlist_Ordertype":  //获取是否显示订单tab
                        this.ordertypelist = item.value&&item.value.length?JSON.parse(item.value):null;
                        if(this.ordertypelist&&this.ordertypelist.indexOf('培训订单')!=-1){
                            this.orderGoodsTypeList.push({
                                value: 1,
                                label: '培训订单'
                            })
                        }
                        if(this.ordertypelist&&this.ordertypelist.indexOf('商品订单')!=-1){
                            this.orderGoodsTypeList.push({
                                value: 3,
                                label: '商品订单'
                            })
                        }
                        if(this.ordertypelist&&this.ordertypelist.includes('线下订单')){
                            this.orderGoodsTypeList.push({
                                value: 0,
                                label: '线下订单'
                            })
                        }
                        if(this.orderGoodsTypeList.length==1&&this.ordertypelist.indexOf('培训订单')!=-1){
                            this.orderGoodsTypeList = [];
                        }
                        if(this.orderGoodsTypeList.length==1&&this.ordertypelist.indexOf('商品订单')!=-1){
                            this.orderGoodsTypeList = [];
                            this.tabActive = 3;
                            this.goodsKinds = 3;
                        }
                        if(this.orderGoodsTypeList.length==1&&this.ordertypelist.includes('线下订单')){
                            this.tabActive = 0;
                            this.orderGoodsTypeList = [];
                        }
                    break;
                    case 'order_list_pingjia':
                      this.isEvaluateBtn = item.value && item.value === 'true' ? true : false;
                    break;
                    case 'order_list_fapiao':
                      this.isInvoice = item.value && item.value === 'true' ? true : false;
                      break;
                    default:
                    break;
                       
                }
            });
        },
        onStatus(num){
            let objNum = {
                1: "查看评价",
                2: "立即评价",
                3: "立即评价",
            };
            num = parseInt(Math.ceil(num));
            return objNum[num];
        },
        // 申请
        handleApply(id,time,ind){ //
            const that = this;
            if(this.listData[ind].invoiceStatus==1){
                var nowDate = new Date().getTime();
                var starDate = new Date(time).getTime();
                var reTime = 365*24*60*60*1000;
                if((starDate + reTime - nowDate)<0){ //过期
                    Toast({
                        message:'此订单申请发票已过期',
                    });
                    return
                }
            }
            this.$router.push({
                path:"/invoicesform",
                query:{
                    id:id
                }
            })
        },
        // 查看
        handlePreview(id){
            this.$router.push({
                path:"/invoicesinfo",
                query:{
                    id:id
                }
            })
        },
        // 评价
        onEvaluate(item){
            const {evaluationTag, orderNo} = item
            // 查看评价
            if(evaluationTag == 1){
                this.$router.push({
                    path: "/lookEvaluate",
                    query: {
                        orderNo
                    }
                });
            } 
            // 评价
            if(evaluationTag == 2){
                this.$router.push({
                    path: "/evaluate",
                    query: {
                        orderNo
                    }
                });
            }
            if(evaluationTag == 3){
                Toast({
                    message:'培训任务完课后，才可评价呦~',
                });
            }
        },
        // 去付款
        goPayment(info,order) {
            if (!localStorage.getItem('token')) {
                this.$router.push({ path: "/login" , query: {name: 'orderpage'}});
            } else {
                // this.$router.push({
                //     path: "/gongxin_payment",
                //     query: {
                //         goodsId: info.id,
                //         orderNo: order.orderNo,
                //         orderType:order.orderType,
                //         // iswx:0,
                //         goodsKinds:order.goodsList[0].goodsKinds
                //     }
                // });
                this.$api.home
                .prePayOrder({
                    // 调用订单号
                    data: {
                        orderId: order.id,
                        orderNo: order.orderNo,
                        totalMoney: order.realPay,
                        payInfoDesc: "",
                        scene: 4,
                        agentId: localStorage.getItem('detailAgentId') || ''

                    }
                })
                .then(async(res) => {
                    if (res.message === "success") {
                        let url  = ''
                        let locationHref = window.location.href
                        if (locationHref.includes('testing')) {
                            url = 'pay.testing3.wdeduc.com'
                        } else if (locationHref.includes('fat')) {
                            url = 'pay.fat.wdeduc.com'
                        } else if (locationHref.includes('uat')) {
                            url = 'pay.uat.wdeduc.com'
                        } else  {
                            url = 'pay.wdeduc.com'
                        }
                        // 跳转支付系统，在返回使用的标记
                        // localStorage.setItem('hasJumpCashier', 1)
                        const successBackUrl = encodeURIComponent(window.location.protocol+'//'+window.location.hostname)
                        const backUrl = window.location.origin+`/gongxin_payment?goodsId=${info.id}&isGroupGood=${order.groupOrderTag?1:''}&backUrl=`;
                        let mineMenu = sessionStorage.getItem('mineMenu')
                        if (!mineMenu) {
                          mineMenu = '/saccount'
                        }
                        const data = {
                            key: order.orderNo,
                            value: JSON.stringify({
                                orderNo: order.orderNo,
                                organ: localStorage.getItem("organ"),
                                token: localStorage.getItem("token"),
                                actor: localStorage.getItem("actor"),
                                branch: localStorage.getItem("branch"),
                                backUrl: backUrl,
                                id: info.id,
                                goodsKinds:info.goodsKinds,
                                referId: info.referId,
                                orderType: order.orderType,
                                successBackUrl: successBackUrl,
                                CSuccessBackUrl: window.location.origin+`/orderpage?backPath=${mineMenu}`
                            })
                        }

                        let result = await this.$api.orderPage.jumpPaySaveParams(data)
                        // alert(result.code+'----'+this.handelPaylist.orderNo)
                        // if(result.success) {
                        //     window.location.href = `https://${url}/cashier?orderNo=${this.handelPaylist.orderNo}`
                        // }

                        window.location.href =
                            "https://" +
                            `${url}` +
                            "/cashier?orderNo=" +
                            `${order.orderNo}` +
                            "&organ=" +
                            localStorage.getItem("organ") +
                            "&token=" +
                            localStorage.getItem("token") +
                            "&actor=" +
                            localStorage.getItem("actor") +
                            "&branch=" +
                            localStorage.getItem("branch") +
                            "&backUrl=" +
                            window.location.origin +
                            "&id=" +
                            info.id + 
                            "&orderType=" +
                            order.orderType +
                            '&successBackUrl=' + successBackUrl
                    }
                });
            }
        },
        goDetails(item,order){
            /**
             * orderType 4 
             * goodsKind 1 普通商品 2 分销商品
             */
           this.$router.push({
                path: "/goodsDetail",
                query: {
                    goodsId: item.id,
                    goodsKind:order.orderType == 4 ? 2 : 1,
                    backName:this.$route.path,
                    backPath:this.$route.query.backPath
                }
            });
        },
        formatNumber(num){
            return num > 10 ? num :('0'+num)
        },
        countDown(){
            var that = this;
            that.timer = setInterval(function () {
                var orders = that.listData;
                for (var i = 0; i < orders.length; i++) {
                    var status = orders[i].status;
                    if (status == 0) {
                        var orderTime = orders[i].orderTime.replace(/-/g,'/');
                        //计算剩余时间差值
                        var leftTime = Number(new Date(orderTime).getTime() + 30 * 60 * 1000) - Number(new Date().getTime());
                        // console.log(leftTime,'======leftTime')
                        if (leftTime > 0) {
                            //计算剩余的分钟
                            var minutes = that.formatNumber(parseInt(leftTime / 1000 / 60 % 60, 10));
                            //计算剩余的秒数
                            var seconds = that.formatNumber(parseInt(leftTime / 1000 % 60, 10));
                            var left_time = minutes + ":" + seconds;
                            orders[i].left_time = left_time;
                        }else{
                        //改变超时未支付的订单状态
                            that.listData[i].status = 8;
                        }
                    }
                    if(orders[i].invoiceStatus==1){
                        var nowDate = new Date().getTime();
                        var starDate = new Date(orders[i].orderTime).getTime();
                        var reTime = 365*24*60*60*1000;
                        if((starDate + reTime - nowDate)<0){ //过期
                            that.listData[i].invoiceStatus = 3;
                        }
                    }
                }
                that.listData = orders;
                // console.log(that.orderlist,'that.orderlist======')
                that.$forceUpdate();
            }, 1000);
        },
        setCompatible() {
            if(localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
                this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
            }
        },
        goRefund(item){
            console.log('===',item)
            if(item.deliveryStatus == 3){
                

                this.$router.push({
                  path:'/submitRefund',
                  query:{
                    id:item.goodsList[0].id, //  商品id
                    orderId:item.id, //订单id
                    type:0,
                    orderNo:item.orderNo, // 订单编号
                    url:'orderpage'
                  }
                })
               
            }else {
                this.$router.push({
                  path:'/shippedRefund',
                  query:{
                    id:item.goodsList[0].id, //  商品id
                    orderId:item.id, //订单id
                    orderNo:item.orderNo,
                    url:'orderpage'
                  }
                })
            } 
            
        },
        async getDataList() {
            this.dataLoading = true;
            let data = { // 培训订单
                orderStatus: this.orderType,
                goodsKinds: this.goodsKinds,
            }
            if([3].includes(this.tabActive)){ // 商品订单
                data = {
                    orderStatus: this.orderType,
                    goodsKinds: this.goodsKinds,
                    toC: 1,
                }
            }
            await this.$api.account.getOrderList(data,this.filter).then((res)=>{
                if(res.success) {
                    this.error = false;
                    if (this.refreshing) {
                        this.listData = [];
                        this.refreshing = false;
                    }
                    const {list, total} = res.data
                    if(this.filter.pageNum === 1) {
                        this.listData = list;
                    } else {
                        this.listData = this.listData.concat(list);
                    }
                    this.loading = false;
                    if(this.listData.length >= total) {
                        this.loading = true;
                        this.finished = true;
                    } else {
                        this.filter.pageNum++;
                    }
                } else {
                    this.error = true;
                    this.loading = false;
                }
                this.dataLoading = false;
            },()=>{
                this.error = true;
                this.loading = false;
                this.dataLoading = false;
            })
        },
        onChangePage(page = 1) {
            window.scrollTo(0,0)
            this.finished = false;
            this.filter.pageNum = page;
            if(this.tabActive){
              this.getDataList();
            }else{
              this.getOfflineOrderData();
            }
        },
        
        // 线下订单列表
        async getOfflineOrderData(){
            this.dataLoading = true;
            const data = {
              statusList:[1,2]
            }
            const params = {
                pageNum:this.filter.pageNum,
                pageSize:this.filter.pageSize
            }
           
            await this.$api.account.getOfflineOrder({data,params}).then((res)=>{
                if(res.success) {
                    this.error = false;
                    if (this.refreshing) {
                        this.offlineOrderList = [];
                        this.refreshing = false;
                    }
                    const {list, total} = res.data
                    if(this.filter.pageNum === 1) {
                        this.offlineOrderList = list;
                    } else {
                        this.offlineOrderList = this.offlineOrderList.concat(list);
                    }
                    this.loading = false;
                    if(this.offlineOrderList.length >= total) {
                        this.loading = true;
                        this.finished = true;
                    } else {
                        this.filter.pageNum++;
                    }
                } else {
                    this.error = true;
                    this.loading = false;
                }
                this.dataLoading = false;
            },()=>{
                this.error = true;
                this.loading = false;
                this.dataLoading = false;
            })
        },
        handleTab(value) {
            this.listData = [];
            this.offlineOrderList = [];
            this.goodsKinds = value;
            this.orderType = '';
            this.onChangePage();
        },
        handleDetail(orderNo) {
            console.log(orderNo,'orderNo')

            if(this.goodsKinds == 1) {
                return false;
            }
            if(this.goodsKinds == 5){
                this.$router.push({
                  name:'combinedOrderDetail',
                  params:{
                    orderNo,
                    orderStatus: this.orderType,
                    type: 5
                  }
                })
            }else if(this.goodsKinds == 3){
                this.$router.push({name: 'orderDetail',params: {
                    orderNo,
                    orderStatus: this.orderType,
                    type: 3,
                    backPath:this.$route.query.backPath
                }})
            }
            
        },
        handleStatus(status) {
            this.orderType = status;
            this.onChangePage();
        },
        formatStatus(status) {
            const resutl = payStatusList.filter(v=>v.value === status)
            return resutl.length? resutl[0].label : ''
        },
        onLoad() {
            console.log(111);
            if(this.tabActive){
              this.getDataList();
            }else{
              this.getOfflineOrderData();
            }
        },
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.filter.pageNum = 1;
            this.onLoad();
        },
        buyClickLog(item) {
            const {branchId: commodity_id, name: commodity_name, salePrice: current_price } = item.goodsList[0]
            const logParams = {
                buy_type: '',
                commodity_id,
                institution_name: '',
                commodity_firstcate: '',
                commodity_secondcate: '',
                commodity_thirdcate:'',
                commodity_name,
                original_price: current_price,
                current_price,
            }
            this.$sensors.track('buy_commodity_click', {
                ...logParams,
            })
        }, 
        handlePay({orderNo, id, realPay, orderType}) {
            
            // alert(`付款orderNo:${item.orderNo}`)
            this.$api.home
                .prePayOrder({
                    // 调用订单号
                    data: {
                        orderId: id,
                        orderNo,
                        totalMoney: realPay,
                        payInfoDesc: "",
                        scene: 4,
                        agentId: localStorage.getItem('detailAgentId') || ''
                    }
                })
                .then(async(prePayRes) => {
                    if (prePayRes.message === "success") {
                        let url  = ''
                        let locationHref = window.location.href
                        if (locationHref.includes('testing')) {
                            url = 'pay.testing3.wdeduc.com'
                        } else if (locationHref.includes('fat')) {
                            url = 'pay.fat.wdeduc.com'
                        } else if (locationHref.includes('uat')) {
                            url = 'pay.uat.wdeduc.com'
                        } else  {
                            url = 'pay.wdeduc.com'
                        }
                        // 跳转支付系统，在返回使用的标记
                        localStorage.setItem('hasJumpCashier', 1)
                        const successBackUrl = encodeURIComponent(window.location.protocol+'//'+window.location.hostname)
                        // const backUrl = this.isInApp ? window.location.origin + `/payComplete` : window.location.origin + `/myPage`
                        const backUrl = window.location.origin + (this.$route.query.backPath?this.$route.query.backPath:'/saccount')
                        const data = {
                            key: orderNo,
                            value: JSON.stringify({
                                orderNo,
                                organ: localStorage.getItem("organ"),
                                token: localStorage.getItem("token"),
                                actor: localStorage.getItem("actor"),
                                branch: localStorage.getItem("branch"),
                                platform: localStorage.getItem("type"),
                                backUrl,
                                iOSstatusBarHeight: localStorage.getItem('statusBarHeight'),
                                iOSbottomSafeHeight: localStorage.getItem('bottomSafeHeight'),
                                id,
                                // referId: this.goodsList.referId,
                                orderType,
                                successBackUrl: successBackUrl,
                                CSuccessBackUrl: backUrl
                                // CSuccessBackUrl: window.location.origin + `/payComplete?backUrl=/order/detail/${orderNo}&goodsId=${id}`
                            })
                        }

                        if (this.lng) {
                        const orderIdJson = JSON.stringify({
                          order_id: `${id}`,
                        })

                        try {
                          await this.$api.user.saveUserLocation({
                            location: `${this.lng},${this.lat}`,
                            info: orderIdJson,
                            province: this.province,
                            city: this.city,
                            distinct: this.distinct,
                            type: 3,
                          });
                        } catch (error) {
                          // ...
                        }
                      }

                        let result = await this.$api.orderPage.jumpPaySaveParams(data)
                        // alert(result.code+'----'+this.handelPaylist.orderNo)
                        // if(result.success) {
                        //     window.location.href = `https://${url}/cashier?orderNo=${this.handelPaylist.orderNo}`
                        // }

                        window.location.href =
                            "https://" +
                            `${url}` +
                            "/cashier?orderNo=" +
                            `${orderNo}` +
                            "&organ=" +
                            localStorage.getItem("organ") +
                            "&token=" +
                            localStorage.getItem("token") +
                            "&actor=" +
                            localStorage.getItem("actor") +
                            "&branch=" +
                            localStorage.getItem("branch") +
                            "&backUrl=" +
                            backUrl +
                            "&id=" +
                            id + 
                            "&orderType=" +
                            `${orderType}` +
                            '&successBackUrl=' + successBackUrl +
                            "&type=" +
                            'pay3'
                    }
                });
        },
        
        onClickLeft() {
            if(this.$route.query.backPath){
                this.$router.replace({
                    path: this.$route.query.backPath
                });
            }else if(this.$route.query.usego){
                this.$router.go(-1)
            }else{
                if(this.isNewSaas){
                    this.$router.push('/personalCenter_new');
                }else{
                    this.$router.push('/saccount');
                }   
            }
        },
        // initMap() {
        //   this.mapToast = Toast.loading({
        //     message: "加载中...",
        //     duration: 0,
        //     forbidClick: true,
        //   });

		// 	let that = this
		// 	AMapLoader.load({
		// 		key: '66bb11010b577f7a0ecfe0a362093862', // 申请好的Web端开发者Key，首次调用 load 时必填
		// 		version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
		// 		plugins: ['AMap.Geocoder', 'AMap.Geolocation', 'AMap.Autocomplete'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
		// 	})
		// 		.then((AMap) => {
		// 			// this.map = new AMap.Map("container",{  //设置地图容器id
		// 			//   // viewMode: "3D",    //是否为3D地图模式
		// 			//   zoom: this.zoom,           //初始化地图级别
		// 			//   center: this.center, //初始化地图中心点位置
		// 			// });
		// 			AMap.plugin('AMap.Geolocation', function () {
		// 				var geolocation = new AMap.Geolocation({
		// 					// 是否使用高精度定位，默认：true
		// 					enableHighAccuracy: true,
		// 					// 设置定位超时时间，默认：无穷大
		// 					timeout: 10000,
		// 					// 定位按钮的停靠位置的偏移量
		// 					offset: [10, 20],
		// 					//  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
		// 					zoomToAccuracy: true,
		// 					//  定位按钮的排放位置,  RB表示右下
		// 					position: 'RB',
		// 				})

		// 				geolocation.getCurrentPosition(function (status, result) {
		// 					if (status == 'complete') {
		// 						onComplete(result)
		// 					} else {
		// 						onError(result)
		// 					}
		// 				})

		// 				function onComplete(data) {
		// 					// data是具体的定位信息
		// 					console.log('==== onComplete', data)
		// 					try {
        //                         const province = data?.addressComponent?.province || '';
        //                         const city = data?.addressComponent?.city || province || '';
        //                         const district = data?.addressComponent?.district || '';

		// 						that.lng = data.position.lng || '';
		// 						that.lat = data.position.lat || '';
        //                         that.province = province;
        //                         that.city = city;
        //                         that.distinct = district;

        //                         that.mapToast.clear();
		// 					} catch (e) {
		// 						console.log('==== onComplete catch', errorMonitor)

        //                         that.mapToast.clear();
		// 					}
		// 				}

		// 				function onError(data) {
		// 					// 定位出错
		// 					console.log('==== onError', data)

        //                     that.mapToast.clear();
		// 				}
		// 			})
		// 		})
		// 		.catch((e) => {
        //             this.mapToast.clear();
		// 			console.log(e)
		// 		})
		// },
    },
}
</script>
<style lang="less">
body,html {
    background-color: #F8FAFC;
}
</style>

<style lang="less" scoped>
.px2rem(@name,@px){
    @{name}: @px / 37.5px * 1rem
}
::v-deep{
    .van-pull-refresh {
        min-height: 60vh;
    }
    .van-sticky {
        background-color: #fff;
    }
    .van-button--primary  {
        border: 1px solid #FE5746;
        color: #FE5746;
        .px2rem(border-radius,44);
        .px2rem(height,60);
        .px2rem(width,168);
        .px2rem(font-size,26);
    }
    .van-hairline--bottom::after {
        display: none;
    }
}
// 线下订单
.offlineOrderItem{
    width: 690px;
    box-sizing: border-box;
    border-radius: 16px;
    background: #fff;
    padding: 40px 32px 20px;
    margin: 24px auto 24px;
    position: relative;
    .pay-icon{
      position: absolute;
      right: 50px;
      top:0;
      width: 136px;
    }
    .orderNo,.tradeTime{
        .label{
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 26px;
        }
        .con{
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 26px;
        }
    }
    .tradeTime{
        margin-top: 16px;
    }
    .details{
      display: flex;
      align-items: center;
      margin: 30px 0;
      img{
          width: 242px;
          height: 182px;
      }
      .name{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 48px;
        flex: 1;
        margin-left: 29px;
      }
    }
    .bottom{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 17px;
      border-top: 1px solid #D7D7D7;
      .paymentAmount{
        .label{
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
        }
        .con{
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F1430D;
          line-height: 32px;
        }
      }
      .button{
        width: 168px;
        height: 60px;
        border-radius: 44px;
        border: 1px solid #3860FF;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3860FF;
        text-align: center;
        line-height: 60px;
      }
    }
}
.refund-text{
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 37px;
}
.refund-btn{
    width: 168px;
    height: 60px;
    border-radius: 44px;
    border: 1px solid #D8D8D8;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}
.goods-type-box {
    ::v-deep {
        .van-tab {
            color: #999;
            &.van-tab--active {
                color: #333;
            }
            .van-tab__text {
                .px2rem(font-size,32);
            }
        }
        .van-tabs__line {
            .px2rem(width,40);
            .px2rem(height,8);
            background-color: #1F94FF;
        }
    }
}
.loadingWrap {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
}
.status-nav-box {
    background-color: #fff;
    display: flex;
    justify-content: center;
    padding: 32px 0px;
    border-bottom: 1px solid #eaeaea;
    margin-top: 6px;
    .status-nav-item {
        margin: 0 15px;
        background-color: #F5F6FA;
        border-radius: 6px;
        color: #333;
        font-size: 26px;
        border: 1px solid #F5F6FA;
        box-sizing: border-box;
        padding: 14px 16px;
        &.cur {
            background-color: rgba(31, 148, 255, 0.12);
            border-color: #0089FF;
            color: #0089FF;
        }
    }
    ::v-deep {
        .van-tabs__wrap {
            .px2rem(height,56);
        }
        .van-tabs__line {
            display: none;
        }
        .van-tabs__nav--line.van-tabs__nav--complete{
            padding-right: 15px;
        }
        .van-tab {
            margin: 0;
            .px2rem(margin-left,15);
            .px2rem(margin-right,15);
            background-color: #F5F6FA;
            color: #333;
            border: 1/37.5rem solid #F5F6FA;
            box-sizing: border-box;
            padding: 0;
            .px2rem(padding-left,16);
            .px2rem(padding-right,16);
            .px2rem(font-size,26);
            .px2rem(border-radius,6);
            .px2rem(height,56);
            
            flex: none;
            &.van-tab--active {
                background-color: rgba(31, 148, 255, 0.12);
                border-color: #0089FF;
                color: #0089FF;
                font-weight: normal;
            }
            .van-tab__text {
                overflow: visible;
                display: block;
            }
        }

    }
}
.orderul{
    padding:24px 30px;
    .groupBtn{
        text-align:center;
        width: 217px;
        height: 60px;
        border-radius: 44px;
        border: 1px solid #3860FF;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3860FF;
        line-height: 60px;
    }
    button{
        outline:none;
        border:none;
        background:transparent;
    }
    .btn_wrap{
        display: flex;
        align-items: center
    }
    .applyBtn{
        color:#fff;
        background: #3860FF;
        border-radius: 44px;
        height:60px;
        width:168px;
        text-align:center;
        font-size:26px;
    }
    .previewBtn{
        color:#3860FF;
        border-radius: 44px;
        border: 1px solid #3860FF;
        height:60px;
        width:168px;
        text-align:center;
        font-size:26px;
    }
    .payBtn{
        color:#fff;
        background: #F1430D;
        border-radius: 44px;
        height:60px;
        width:168px;
        text-align:center;
        font-size:26px;
    }
    .evaluate{
        margin-left: 16px;
        .btn_evalute{
            height:60px;
            width:168px;
            border-radius: 44px;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
        }
        .c1{
            color: #FF8131;
            border: 2px solid #FF8131;
        }
        .c2{
            color: #fff;
            background: #FF8131;
        }
        .c3{
            background: #CBCED5;
            color: #fff;
            border: 1px solid #CBCED5;
        }
    }
    .order-bottom{
        display: flex;
        align-items:center;
        justify-content: space-between;
        border-top: 1px solid #EAEAEA;
        margin:0 32px;
    }
    .orderli{
        background: #fff;
        border-radius: 16px;
        width: 100%;
        position: relative;
        margin-bottom: 24px;
        .orderinfo{
            padding: 34px 20px 24px 32px;
            .payicon{
                position: absolute;
                right: 48px;
                top: 0px;
                display: inline-block;
                width: 136px;
                height: 106px;
            }
            .orderText{
                font-size: 26px;
                color: #999;
                font-family: PingFangSC-Regular, PingFang SC;
                line-height: 40px;
                span{
                    color: #333;
                }
            }
        }
        .orderCurseInfo{
            display: flex;
            align-items: center;
            padding: 0px 30px;
            margin-bottom: 34px;
            .orderCourseImg{
                display: inline-block;
                width: 240px;
                height: 180px;
                background: #C8C8C8;
                border-radius: 16px;
                margin-right: 26px;
            }
            h3{
                width: 364px;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                color: #333333;
                line-height: 36px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                .pt-icon{
                    display: inline-block;
                    padding:8px 12px;
                    background: rgba(254,87,70,0.1200);
                    border-radius: 4px;
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FE5746;
                    line-height: 20px;
                    vertical-align:middle;
                    margin-right:6px;
                }
                .title-text{
                    vertical-align:middle;
                }
            }
        }
        .orderprice{
            color: #333;
            height: 96px;
            line-height: 96px;
            text-align: right; 
            font-size: 26px;
            span{
                line-height: 1;
                color: #F1430D;
                font-size:32px;
            }
        }
    }
}
    
.list-box {
    padding: 24px 16px 0;
    .list-item {
        background: #FFFFFF;
        border-radius: 16px;
        border: 2px solid #EAEAEA;
        margin-bottom: 24px;
        padding: 22px 18px 0;
        position: relative;
    }
    .num-box {
        margin-bottom: 14px;
        .num-item {
            display: flex;
            font-size: 28px;
            width: 100%;
            line-height: 28px;
            margin-bottom: 22px;
            &:last-of-type {
                margin-bottom: 0;
            }
            .name {
                color: #999;
            }
            .info {
                color: #333;
            }
        }
        .status-text {
            position: absolute;
            right: 23px;
            top: 18px;
            color: #F1430D;
            font-size: 32px;
            height: 48px;
            line-height: 48px;
        }
    }
    .pay-info-box {
        box-shadow: inset 0px 1px 0px 0px #D7D7D7;
        display: flex;
        align-items: center;
        height: 110px;
        position: relative;
        &.no-pay {
            justify-content: space-between;
            .pay-info-item {
                flex-direction: column;
            }
        }
        .pay-info-item {
            display: flex;
            flex: 1;
            justify-content: space-between;
        }
        .pay-info-num {
            color: #666;
            margin-right: 24px;
            font-size: 24px;
            display: flex;
            P{
                margin-right: 24px;
            }
            &:last-of-type {
                margin: 0;
            }
            span {
                font-size: 32px;
                color: #F1430D;
            }
        }
        .pay-detail {
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
        .pay-price-text {
            color: #666;
            font-size: 26px;
        }
        .pay-price {
            color: #F1430D;
            font-size: 32px;
        }
        .exchangeTag {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 126px;
            height: 96px;
            background: url(../asset/images/exChange_icon.png) no-repeat center center /100% 100%;
        }
    }
}
</style>